import type {ComponentType} from 'react';
import {lazy} from 'react';
import type {TurnIntoVideoButtonProps} from './turn-into-video-button.types';

/** Loaded on demand: its video hook imports ai-chat.library, which already imports the button group through the stream registry. */
// eslint-disable-next-line @typescript-eslint/naming-convention -- a component, rendered as JSX
export const LazyTurnIntoVideoButton = lazy(async (): Promise<{default: ComponentType<TurnIntoVideoButtonProps>}> => {
  const turnIntoVideoButtonModule = await import('./turn-into-video-button');

  return {default: turnIntoVideoButtonModule.TurnIntoVideoButton};
});
